export default __webpack_public_path__ + "static/1821-ee2bf6562e60a6f7e33612e346555a9f.gif";